/**
 * Site images that promotions can use by key (promotions.image_key).
 * Files live in public/promo-assets so the admin app can preview them by URL.
 * Keep in sync with kofc1056_api/src/promotions/promo-assets.ts.
 */
export const PROMO_ASSETS: Record<string, { label: string; path: string }> = {
  'lucky-calendar-2027': { label: 'Lucky Calendar 2027 (church)', path: '/promo-assets/lucky-calendar-2027.jpg' },
  'lucky-number-calendar': { label: 'Lucky Number Calendar', path: '/promo-assets/lucky-number-calendar.jpg' },
  'fish-fry': { label: 'Fish Fry', path: '/promo-assets/fish-fry.png' },
  'golf-outing': { label: 'Golf Outing', path: '/promo-assets/golf-outing.png' },
  'purse-bingo': { label: 'Purse Bingo', path: '/promo-assets/purse-bingo.jpg' },
  'christmas-donuts': { label: 'Christmas Donuts', path: '/promo-assets/christmas-donuts.png' },
  'christmas-presale': { label: 'Christmas Presale', path: '/promo-assets/christmas-presale.png' },
  'halloween-donuts': { label: 'Halloween Donuts', path: '/promo-assets/halloween-donuts.png' },
  'festival': { label: 'Festival', path: '/promo-assets/festival.png' },
  'fourth-of-july': { label: 'Fourth of July', path: '/promo-assets/fourth-of-july.png' },
  'raffle': { label: 'Raffle', path: '/promo-assets/raffle.png' },
  'dipped-donut': { label: 'The Dipped Donut', path: '/promo-assets/dipped-donut.png' },
  'kofc-logo': { label: 'KofC 1056 Logo', path: '/promo-assets/kofc-logo.jpg' },
};

/** image_url (uploaded) wins; otherwise resolve image_key; otherwise undefined. */
export function resolvePromoImage(imageUrl?: string | null, imageKey?: string | null): string | undefined {
  if (imageUrl) return imageUrl;
  if (imageKey && PROMO_ASSETS[imageKey]) return process.env.PUBLIC_URL + PROMO_ASSETS[imageKey].path;
  return undefined;
}
